import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {
    active?: boolean
}

export const StyledQueueIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M24.9534 7.4375L17.0732 7.4375" strokeWidth="1.14102" strokeLinecap="round" />
            <path d="M16.937 23.375L7.37451 23.375" strokeWidth="1.14102" strokeLinecap="round" />
            <path d="M24.8133 22.5647L20.973 20.26C20.6566 20.0716 20.1875 20.26 20.1875 20.7143L20.1875 25.3238C20.1875 25.7448 20.6239 25.9997 20.973 25.7891L24.8133 23.4844C25.1516 23.2739 25.1516 22.7752 24.8133 22.5647Z" stroke="none" />
            <path d="M24.9533 18.0625L7.37451 18.0625" strokeWidth="1.14102" strokeLinecap="round" />
            <path d="M24.9533 12.75L7.37451 12.75" strokeWidth="1.14102" strokeLinecap="round" />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    width: 30px;
    height: 30px;
    stroke: ${p => (p.active ? p.theme.playColor : p.theme.textColor)};
    fill: ${p => (p.active ? p.theme.playColor : p.theme.textColor)};
`
